module.exports = "<div class=col-md-7 ng-if=extensionVM.thereIsDetails()> <div ng-include=\"'extension-details-header-projects'\"></div> </div> <div class=\"col-md-7 m-t-lg p-t-lg\" layout=row layout-sm=column layout-align=space-around ng-if=extensionVM.isLoadingDetails> <md-progress-circular md-mode=indeterminate ng-disabled=\"extensionVM.thereIsDetails() || extensionVM.searchValue\" md-diameter=96> </md-progress-circular> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/u-faculty/workplan/extensionVisibility/extensionProjects/list/extension-projects-details.html
// module id = 669
// module chunks = 0